<template>
  <div>
    <modal id="change-name-modal" :modifiers="['no-horizontal-padding']">
      <div class="w-screen max-w-md pt-12 px-6 pb-6">
        <b-headline type="h2" typography="h2">
          {{ $t("headline") }}
        </b-headline>
        <input-text
          disabled
          v-model.trim="newName"
          @input="removeInvalidChars"
          :label="$t('nameLabel')"
          name="name"
          class="flex-grow m:flex-grow-0 m:w-1/2 mb-8"
        />
        <div class="flex justify-between items-center">
          <a class="cursor-pointer" @click="close">
            {{ $t("cancel") }}
          </a>
          <b-button :disabled="!newName.length" @click="submit">
            {{ $t("continue") }}
          </b-button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import Modal from "@/shared/modal"
import BHeadline from "@/component-library/b-headline/index"
import BButton from "@/component-library/b-button/index"
import events from "@/bl-events/index"
import InputText from "@/shared/form/input-text"
import { filterEmoticons } from "@/services/filter-string"

/**
 * @emits submit
 */
export default {
  name: "ChangeNameModal",
  components: {
    BHeadline,
    InputText,
    BButton,
    Modal
  },
  props: {
    name: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      newName: ""
    }
  },
  mounted() {
    events.on("modal:change-name-modal:open", () => {
      this.newName = this.name
    })
  },
  methods: {
    close() {
      events.emit("modal:change-name-modal:close")
    },
    removeInvalidChars() {
      this.newName = filterEmoticons(this.newName)
    },
    submit() {
      this.$emit("submit", this.newName)
      this.close()
    }
  },
  i18n: {
    messages: {
      en: {
        headline: "Change personal information",
        nameLabel: "Name",
        cancel: "Cancel",
        continue: "Change"
      },
      de: {
        headline: "Passe deine persönliche Einladung an",
        nameLabel: "Name",
        cancel: "Löschen",
        continue: "Ändern"
      }
    }
  }
}
</script>
